import { render, staticRenderFns } from "./AccountRegister.vue?vue&type=template&id=7fb2da6c"
import script from "./AccountRegister?vue&type=script&lang=ts&external"
export * from "./AccountRegister?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports